import { render, staticRenderFns } from "./ProductQuickViewVertical.vue?vue&type=template&id=6f7227e4&scoped=true"
import script from "./ProductQuickViewVertical.vue?vue&type=script&lang=js"
export * from "./ProductQuickViewVertical.vue?vue&type=script&lang=js"
import style0 from "./ProductQuickViewVertical.vue?vue&type=style&index=0&id=6f7227e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7227e4",
  null
  
)

export default component.exports